import { render } from "./CustomToggle.vue?vue&type=template&id=18083ed6&scoped=true"
import script from "./CustomToggle.vue?vue&type=script&lang=js"
export * from "./CustomToggle.vue?vue&type=script&lang=js"

import "./CustomToggle.vue?vue&type=style&index=0&id=18083ed6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18083ed6"]])

export default __exports__